import { watch } from 'vue'

import { useAlertsStore } from '../stores/alertsStore'

import { useWorkspace } from '@/features/account'
import { registerSessionReset } from '@/features/auth'

/** Clear volatile alert slices on selected-workspace changes and session teardown. */
export function registerAlertsLifecycle(): () => void {
  const store = useAlertsStore()
  const { workspaceId } = useWorkspace()
  const stopWorkspace = watch(
    workspaceId,
    (next, previous) => {
      if (String(next ?? '') !== String(previous ?? '')) store.reset()
    },
    { flush: 'sync' },
  )
  const unregisterSession = registerSessionReset(() => store.reset())
  return () => {
    stopWorkspace()
    unregisterSession()
  }
}
